import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function SiteFooter() {
	return (
		<div class="row  overlayfooter">
			<div class="row">

				{/* <!-- About --> */}
				<div class="col-lg-4 footer_col">
					<div class="footer_about">
						<div class="logo_container" >
							<a href="#">
								<div class="logo_content d-flex flex-row align-items-end justify-content-start">
									{/* <div class="logo_img"><img src="./images/spst-home-icon.png" alt="logo" className="footerimage"/></div> */}
									{/* <div class="logo_text">Padmanabhaswami Temple </div> */}
								</div>
							</a>
						</div>
						<div class="clear" style={{ paddingTop: '20%' }}>
							<p className="foottest">One of the most famous Lord Subramanya temples in Kerala, Sree Subramanya Swami Temple at Payyanur in Kannur district of Kerala has specific architectural significance. </p>
						</div>
						<div class="footer_social">
							<ul>
								<li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-pinterest" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
							</ul>
						</div>

					</div>
				</div>

				<div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Quick menu</div>
						<ul className="footer_list">
							<li><Link to="/">Home</Link></li>
							<li><Link to="/History">History</Link></li>
							<li><Link to="/Administration">Administration</Link></li>
							<li><Link to="/Contact">Contact</Link></li>
						</ul>
					</div>
				</div>

				<div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Useful Links</div>
						<ul class="footer_list">
							<li><Link to="https://booking.sstemplepayyanur.in/">Online Booking</Link></li>
							<li><Link to="https://booking.sstemplepayyanur.in/Default.aspx">Single Day Booking</Link></li>
							<li><Link to="https://booking.sstemplepayyanur.in/multiple.aspx">Multi Day Booking</Link></li>
							<li><Link to="https://booking.sstemplepayyanur.in/Donation.aspx">E-Kanika</Link></li>
						</ul>
					</div>
				</div>

				<div class="col-lg-4 footer_col">
					<div class="footer_contact">
						<div class="footer_title">Contact Us</div>
						<div class="footer_contact_info">
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Address:</div>
								<div class="footer_contact_line">
									{/* <p className="addr" style={{ color: 'white' }}>Borivili Sree Ayyappa Temple,  <br />
										Sree Ayyappa Seva Sangham – Saibaba Nagar (Regd.) <br />
										Temple Complex, Ram Nagar, <br />
										Borivili, West, Mumbai – 400092</p> */}
								</div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Phone:</div>
								<div class="footer_contact_line white"></div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Email:</div>
								<div class="footer_contact_line white"></div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyrightbottom">
					<div class="row">
						<div class="col-md-8">
							<div class="copyrighttext">
								<p class="foottest" style={{ lineHeight: '20px' }}>Copyright © Sree Subramania Temple Payyanur, All Rights Reserved.  <br /> <Link to="termsandconditions">Terms & Conditions </Link> Enabled by Kshethrasuvidham Temple Management Solutions.</p>
							</div>
						</div>
						<div class="col-md-4">
							<div className="footerlogo">
								<img src="./images/kshethrasuvidhamLogo.jpg" style={{ width: '50%' }} />
							</div>
						</div>
					</div>


				</div>
			</div>
		</div>
	);
}

export default SiteFooter;

